import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import BtnExcel from '../../Components/BtnExcel';
import { formatAmount, getTodayDateISO } from '../../Utils/Common';
import { useLocation } from 'react-router-dom';
import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Select,
    Modal,
    Input,
    Tabs,
    Tag,
    Divider,
} from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { useNavigate } from 'react-router-dom';

const { Search } = Input;
const { TabPane } = Tabs;
const { confirm } = Modal;

const RentalUnit = () => {
  const location = useLocation();
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [viewVisible, setViewVisible] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [unitDetails, setUnitDetails] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
      search: '',
      page: 1,
      status: location?.state? location.state : 'all',
    })
    const [pageSize, setPageSize] = useState('');
    const { callPost, loading } = usePostRequest(()=>{
      fetchRentalData()
    });
    const [rentalData, setRentalData] = useState([])
    const [excelData, setExcelData] = useState([])
    function ActionBtn(row) {
      const items = [
          {
            label: (
              <div onClick={() => showViewModal(row.row)}>
                View
              </div>
            ),
            key: 'view_unit',
          },
          {
            label: (
              <div onClick={() => navigate('/rental-unit/edit/' + row.row.id)}>
                Edit
              </div>
            ),
            key: 'edit_unit',
          },
          {
            label: (
              <div onClick={() => navigate('/rental-unit/history', { state: row.row })}>
                View History
              </div>
            ),
            key: 'history_unit',
          },
          row.row.status === "vacant" && {
            label: (
              <div style={{color: 'red'}} onClick={()=>showDeleteConfirm(row.row.id)}>
                Delete
              </div>
            ),
            key: 'delete_unit',
          },
      ];
   
      return (
        <>
          <span className='center'>
            <Dropdown
              menu={{
              items,
              }}
              trigger={['click']}
            >
              <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
                <Space>
                  <MoreVert />
                </Space>
              </div>
            </Dropdown>
          </span>
        </>
      );
    }

    const showViewModal = (unit_data) => {
      setUnitDetails(unit_data); 
      setViewVisible(true);
    };

    const handleTag = (property_type) => {
      let color = '';
      let name = ''

      if (property_type === "commercial_building") {
        color = 'gold';
        name = 'Commercial';
      } else if (property_type === "raw_lot") {
        color = 'blue';
        name = 'Raw Lot';
      } else if (property_type === "residential_building") {
        color = 'purple';
        name = 'Residential';
      }

      return (
        property_type && <Tag color={color}>{name.toUpperCase()}</Tag>
      );
    }

    async function fetchRentalData() {
      setIsLoading(true);

      const response = await UseGetRequest("rental_units/get", filterConfig);
      if (response.data) {
        const rental_data = response?.data?.data?.map((data) => ({
          id: data.id,
          name: data.name,
          property_id: data.property_id,
          details: data.details,
          furnishing: data.furnishing,
          bathrooms: data.bathrooms,
          bedrooms: data.bedrooms,
          floor_area: parseFloat(data.floor_area),
          pricing_type: data.pricing_type,
          space_area: data.space_area !== "0.00" ? parseFloat(data.space_area) : parseFloat(data.floor_area),
          alfresco_area: data.alfresco_area,
          cusa_area: data.cusa_area,
          unit_price: formatAmount(data.unit_price),
          remarks: data.remarks,
          owner_id: data.owner_id,
          is_managed: data.is_managed,
          manage_type: data.manage_type,
          description: data.description,
          management_fee: data.management_fee,
          agent_fee: data.agent_fee,
          owner_name: data.owner_name,
          owner_contact_no: data.owner_contact_no,
          owner_address: data.owner_address,
          property_name: data.property_name,
          property_address: data.property_address,
          property_type: data.property_type,
          status: data.status,
          added_by: data.added_by,
          added_on: data.added_on,
          updated_by: data.updated_by,
          updated_on: data.updated_on,
        }))
       
        setRentalData(rental_data);
        setPageSize(response?.data?.size)
      } else {
        setRentalData([])
      }

      setIsLoading(false);
    }

    async function fetchExportData() {
      setExportLoading(true)
      const response = await UseGetRequest("rental_units/get",
        {
          search: filterConfig.search,
          type: filterConfig.type,
          bedrooms: filterConfig.bedrooms,
          status: filterConfig.status,
        }
      );
      if (response.data) {
  
        const excel = response?.data?.data?.map((data) => ({
          id: data.id,
          name: data.name,
          details: data.details,
          furnishing: data.furnishing,
          bathrooms: data.bathrooms,
          bedrooms: data.bedrooms,
          floor_area: data.floor_area,
          pricing_type: data.pricing_type,
          space_area: data.space_area,
          alfresco_area: data.alfresco_area,
          cusa_area: data.cusa_area,
          unit_price: data.unit_price,
          manage_type: data.manage_type,
          description: data.description,
          management_fee: data.management_fee,
          agent_fee: data.agent_fee,
          owner_name: data.owner_name,
          owner_contact_no: data.owner_contact_no,
          owner_address: data.owner_address,
          property_name: data.property_name,
          property_address: data.property_address,
          property_type: data.property_type,
          status: data.status,
          remarks: data.remarks,
          added_on: data.added_on,
          updated_on: data.updated_on,
        }))
        setExcelData(excel)
        setExportLoading(false)
      } else {
        setExcelData([])
        setExportLoading(false)
      }
    }

    const showDeleteConfirm = (id) => {
      confirm({
        title: 'Do you want to permanently remove this rental unit?',
        icon: <ExclamationCircleFilled style={{ color: 'red' }}/>,
        content: 'This action cannot be undone.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        confirmLoading: loading,
        onOk() {
          callPost(
            "rental_units/delete", 
            {rental_unit_id: id},
            false
          );
        },
      });
    };

    const handleSearchChange = (e) => {
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e || '',
          page: 1,
        }
      ));
    };
    
    const handleEmpty = (e) => {
      if(e.target.value === ''){
        setFilterConfig((prev) => (
          {
            ...prev,
            search: e.target.value || '',
            page: 1,
          }
        ));
      }
    };

    const onSearchType = (e) => {
      setFilterConfig((prev) => (
        { 
          ...prev,
          type: e || '',
          page: 1,

        }
      ));
    }; 
    const onSearchBedroom = (e) => {
      setFilterConfig((prev) => (
        { 
          ...prev,
          bedrooms: e || '',
          page: 1,

        }
      ));
    }; 
    const onChange = (activeKey) => {
      setFilterConfig((prev) => (
        {
          ...prev,
          status:  activeKey
        }
      ));
    };
    useEffect(() => {
      fetchRentalData();
      fetchExportData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);

    const handleTableChange = (pagination) => {
      setFilterConfig((prev) => ({
        ...prev,
        page: parseInt(pagination.current),
        page_size: pagination.pageSize
        // total_records_per_page: pagination.pageSize,
      }));
    };

    return (
        <Layout className='page'>
          <Navbar navKey={'unit_manager_nav'}/>
          <Layout className='content-container'>
            <Row className='custom-padding responsive-inline responsive-tab-inline'>
              <Col span={9} className='header-container'>
                RENTAL UNIT
              </Col>
              <Col span={15} className='mt-2 responsive-tab-width' align='end'>
                <Space className='responsive-inline'>  
                  <BtnExcel
                    label={"Export to Excel"}
                    size={"sm"}
                    excelData={excelData}
                    xlsxHeaders={[
                      "ID",
                      "Name",
                      "Details",
                      "Furnishing",
                      "Bathrooms",
                      "Bedrooms",
                      "Floor Area",
                      "Pricing Type",
                      "Space Area",
                      "Alfresco Area",
                      "Cusa Area",
                      "Unit Price",
                      "Manage Type",
                      "Description",
                      "Management Fee",
                      "Agent Fee",
                      "Owner Name",
                      "Owner Contact Number",
                      "Owner Address",
                      "Property Name",
                      "Property Address",
                      "Property Type",
                      "Status",
                      "Remarks",
                      "Added On",
                      "Updated On",
                    ]}
                    handleData={fetchExportData}
                    isClicked={exportLoading}
                    fileName={`Rental_Unit_${getTodayDateISO()}.xlsx`}
                  />                  
                  <Button 
                    className='button-color responsive-header-btn' 
                    onClick={() => navigate('/rental-unit/add')} 
                    type="primary"
                  >
                    + Add Rental Unit
                  </Button>
                </Space>
              </Col>
            </Row>
            <Row>
              <Space className='responsive-inline excel-row'>                  
                <Search
                  placeholder="Search..."
                  size='medium'
                  onSearch={(e)=>handleSearchChange(e)}
                  onChange={(e)=>handleEmpty(e)}
                  className='responsive-header-input'
                />    

                <Select
                  placeholder="Select Type"
                  onChange={(e)=>onSearchType(e)}
                  placement='bottomLeft'
                  className='select-field responsive-header-input'
                  align='left'
                  options={[
                    {
                      value: '',
                      label: 'All',
                    },
                    {
                      value: 'residential_building',
                      label: 'Residential Building',
                    },
                    {
                      value: 'commercial_building',
                      label: 'Commercial Building',
                    },
                    {
                      value: 'raw_lot',
                      label: 'Raw Lot',
                    },
                    {
                      value: 'condominium',
                      label: 'Condominium',
                    },
                  ]}
                /> 
                <Select
                  placeholder="Select Bedroom"
                  onChange={(e)=>onSearchBedroom(e)}
                  placement='bottomLeft'
                  className='select-field responsive-header-input'
                  align='left'
                  options={[
                    {
                      value: '',
                      label: 'All',
                    },
                    {
                      value: 'Studio',
                      label: 'Studio',
                    },
                    {
                      value: 'Loft',
                      label: 'Loft',
                    },
                    {
                      value: 'Penthouse',
                      label: 'Penthouse',
                    },
                    {
                      value: '1',
                      label: '1',
                    },
                    {
                      value: '2',
                      label: '2',
                    },
                    {
                      value: '3',
                      label: '3',
                    },
                    {
                      value: '4',
                      label: '4',
                    },
                    {
                      value: '5',
                      label: '5',
                    },
                  ]}
                /> 
              </Space>
            </Row>
            <Row className='page-content'>
              <Col span={24} className='responsive-overflow-auto'>
                <Tabs 
                  defaultActiveKey="all" 
                  type="card" 
                  activeKey={filterConfig?.status}
                  className="custom-tabs"
                  onChange={onChange}
                >
                  <TabPane tab="All" key="all">
                    <AntDTable
                      tableHeaders={[
                        "Property Building",
                        "Unit Number",
                        "Owner Name",
                        "Space/Floor Area",
                        "Details",
                        // "Cusa Area",
                        // "Alfresco Area",
                        "Unit Price",
                        "Bedroom",
                        "Furnishing",
                        "Property Type",
                        "Status",
                        "Manage",
                      ]}
                      headerSelector={[
                        "property_name",
                        "name",
                        "owner_name",
                        "space_area",
                        // "cusa_area",
                        // "alfresco_area",
                        "description",
                        "unit_price",
                        "bedrooms",
                        "furnishing",
                        "property_type",
                        "status",
                        "is_managed"
                      ]}
                      tableData={rentalData}
                      ActionBtn={(row) => ActionBtn(row)}
                      withAction={true}
                      loading={isLoading}
                      tablePages={10}
                      handleTableChange={handleTableChange}
                      filterConfig={filterConfig}
                      totalSize={pageSize}
                      isSearch={true}
                    />
                  </TabPane>
                  <TabPane tab="Vacant" key="vacant">
                    <AntDTable
                      tableHeaders={[
                        "Property Building",
                        "Unit Number",
                        "Owner Name",
                        "Space/Floor Area",
                        "Details",
                        // "Cusa Area",
                        // "Alfresco Area",
                        "Unit Price",
                        "Bedroom",
                        "Furnishing",
                        "Property Type",
                        "Status",
                        "Manage",
                      ]}
                      headerSelector={[
                        "property_name",
                        "name",
                        "owner_name",
                        "space_area",
                        // "cusa_area",
                        // "alfresco_area",
                        "description",
                        "unit_price",
                        "bedrooms",
                        "furnishing",
                        "property_type",
                        "status",
                        "is_managed"
                      ]}
                      tableData={rentalData}
                      ActionBtn={(row) => ActionBtn(row)}
                      withAction={true}
                      loading={isLoading}
                      tablePages={10}
                      handleTableChange={handleTableChange}
                      filterConfig={filterConfig}
                      totalSize={pageSize}
                      isSearch={true}
                    />
                  </TabPane>
                  <TabPane tab="Occupied" key="occupied">
                    <AntDTable
                      tableHeaders={[
                        "Property Building",
                        "Unit Number",
                        "Owner Name",
                        "Space/Floor Area",
                        "Details",
                        // "Cusa Area",
                        // "Alfresco Area",
                        "Unit Price",
                        "Bedroom",
                        "Furnishing",
                        "Property Type",
                        "Status",
                        "Manage",
                      ]}
                      headerSelector={[
                        "property_name",
                        "name",
                        "owner_name",
                        "space_area",
                        // "cusa_area",
                        // "alfresco_area",
                        "description",
                        "unit_price",
                        "bedrooms",
                        "furnishing",
                        "property_type",
                        "status",
                        "is_managed"
                      ]}
                      tableData={rentalData}
                      ActionBtn={(row) => ActionBtn(row)}
                      withAction={true}
                      loading={isLoading}
                      tablePages={10}
                      handleTableChange={handleTableChange}
                      filterConfig={filterConfig}
                      totalSize={pageSize}
                      isSearch={true}
                    />
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
            <Modal
              title="View Rental Unit"
              confirmLoading={loading}
              open={viewVisible}
              // onOk={handleEditOk}
              onCancel={() => setViewVisible(false)}
              okText="Save"
              maskClosable={false}
              width={1000}
              footer={null} 
            >
              <Row className='mb-4'>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Rental Unit: </div>
                      {unitDetails.name}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Property Name: </div>
                      {unitDetails.property_name}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Property Type: </div>
                      {handleTag(unitDetails.property_type)}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Property Address: </div>
                      {unitDetails.property_address}
                    </Space>
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Floor Area: </div>
                      {unitDetails.floor_area}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Bedrooms: </div>
                      {unitDetails.bedrooms}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Bathrooms: </div>
                      {unitDetails.bathrooms}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Furnished: </div>
                      {unitDetails.furnishing}
                    </Space>
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Pricing Type: </div>
                      {unitDetails.pricing_type}
                    </Space>
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Space Area (sqm): </div>
                      {unitDetails.space_area}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Cusa Area (sqm): </div>
                      {unitDetails.cusa_area}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Alfresco Area (sqm): </div>
                      {unitDetails.alfresco_area}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Unit Price: </div>
                      {unitDetails.unit_price}
                    </Space>
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Details: </div>
                      {unitDetails.description}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>With Insurance: </div>
                      {unitDetails.with_insurance}
                    </Space>
                </Col>
              </Row>
              <Divider className='divider-text mt-2'>Owner Information</Divider>
              <Row className='mb-4'>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Owner Name: </div>
                      {unitDetails.owner_name}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Contact Number: </div>
                      {unitDetails.owner_contact_no}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Address: </div>
                      {unitDetails.owner_address}
                    </Space>
                </Col>
                <Col span={6}>
                    <Space direction='vertical'>
                      <div className='view-text'>Remark: </div>
                      {unitDetails.remarks}
                    </Space>
                </Col>
              </Row>
             
            </Modal>
          </Layout>
        </Layout>
    )
}

export default RentalUnit
